// extracted by mini-css-extract-plugin
module.exports = {"MenuHeader":"MenuHeader___YObhk","BackIcon":"BackIcon___3Ur4b","TitleWrap":"TitleWrap___20Rzc","TitleIcon":"TitleIcon___-Wzv6","loading":"loading___3rXRk"};